export default __webpack_public_path__ + "static/media/Sagar-Kamble-FrontEnd-ReactJS.23888376.pdf";